<template>
  <div class="f-shop-detail-subsidySettlement tabs-item" id="subsidySettlement">
    <div class="title">补贴结算</div>
    <div class="content">
      <div>
        <div class="content-title">是否开启审批</div>
        <div class="content-value">
            <el-row class="row">
              <el-col class="col-title" :span="6">是否开始审批:</el-col>
              <el-col class="col-value" :span="18">{{ subsidySettleConfig.enableAudit?'是':'否' }}</el-col>
            </el-row>
        </div>
        <div class="content-title">设置结算时间</div>
        <div class="content-value">
            <el-row class="row">
              <el-col class="col-title" :span="6">设置结算时间:</el-col>
              <el-col class="col-value" v-if="subsidySettleConfig.settleType" :span="18">{{ onSettleType(subsidySettleConfig.settleType)}}</el-col>
            </el-row>
        </div>
      </div>
       <auth-button auth="subsidySettle:update" class="edit-btn">
        <div @click="onEdit" class="custom-button">编辑</div>
      </auth-button>
    </div>
    <!-- <div class="not-set" v-else>
      <auth-button auth="finance:ratio:create">
        <div :class="storeDisable ? 'disabled custom-button' : 'custom-button'" @click="onSet">设置活动费率</div>
      </auth-button>
      <div class="hint">还未设置活动费率（活动费率，优惠券分摊）</div>
    </div> -->
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import { api_getCouponApportionData } from '@/api/finance'

export default {
  name: "fsDetailSubsidySettlement",
  components: {
    AuthButton
  },
  props: {
    subsidySettleConfig: {
      type: Object,
      default() {
        return {}
      }
    },
    storeDisable: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  data() {
    return {
      test: false,
    };
  },
  created() {
  },
  mounted() {
    this.$emit('initPage')
  },
  updated() {
  },
  methods: {
    // 点击编辑
    onEdit() {
       this.$router.push(`/financeShop/index/setRate?id=${this.$route.query.id}`)
    },
    // 结算时间数据格式化
    onSettleType(settleType){
      if(settleType.charAt(0)=='T'){
        return `${settleType.charAt(0)}+${settleType.charAt(1)}天结算`
      }else{
        const index = settleType.indexOf('T'); 
        return `订单${settleType.substr(0,index)}天后T+1结算`
      }
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.f-shop-detail-subsidySettlement {
  min-height: 300px;
  padding: 20px;
  background-color: #fff;
  margin-bottom: 20px;
  border-radius: 4px;

  .content {
    position: relative;
    .content-title {
      color: #333;
      font-size: 16px;
      font-weight: 500;
    }

    .content-value {
      width: 600px;
      background: #f2f3f5;
      padding: 20px;
      margin: 20px 0;
    }

    .edit-btn {
      position: absolute;
      right: 0px;
      bottom: 0px;
    }
  }

  .custom-button {
    min-width: 110px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    border-radius: 2px;
    background: #05C8AF;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    border: 1px solid #05C8AF;
    cursor: pointer;

    &:hover {
      background: #37d3bf;
      border: 1px solid #37d3bf;
    }

    &.disabled {
      background: #82e4d7;
      border: 1px solid #82e4d7;
      cursor: not-allowed;
    }
  }

  .not-set {
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .hint {
      font-size: 12px;
      color: #999999;
      margin-top: 10px;
      margin-bottom: 55px;
    }
  }

  .row {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: #666666;

    .col-title {
      text-align: right;

      &.left {
        text-align: left;
      }
    }

    .col-value {
      color: #333333;
      font-weight: 500;
    }
  }

  .title {
    margin: 0;
    margin-bottom: 30px;
    margin-left: 20px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    &::before {
      position: absolute;
      top: 0;
      left: -15px;
      content: "";
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05c8af;
    }
  }
}
</style>
